export default __webpack_public_path__ + "static/media/imageForFilter1_648x448.fe3b1418.jpg";